import TypeAhead from '@intercom/embercom-composer/components/base/type-ahead';
import { inject as service } from '@ember/service';
import { action } from '@ember/object';
import { map } from '@ember/object/computed';
import Em from 'ember';
export default TypeAhead.extend({
  type: 'savedReply',
  savedReplySearchService: service(),
  triggerCharacter: '#',
  minimumQueryLength: 0,
  triggerWidth: 8,
  matchingItems: [],
  selectableItems: map('savedReplies.@each.{id,name,summary,insertions_count}', function (reply) {
    return Em.Object.create({
      key: `#${reply.get('name')}`,
      id: reply.get('id'),
      name: reply.get('name'),
      summary: reply.get('summary'),
      sortInsertionsCount: reply.get('insertions_count') || 0
    });
  }),
  searchSavedReplies: action(function (textBeforeCursor) {
    if (!textBeforeCursor) {
      return;
    }
    let query = this.get('query');
    let app = this.savedReplySearchService.app;
    let results = [];
    if (query.length > 0) {
      if (app.canUseSavedRepliesFuzzySearch) {
        results = this.savedReplySearchService.typeaheadSearch(query.substring(1));
      } else {
        let items = this.get('items');
        results = items.find(query) || [];
      }
      let regexResults = this.savedReplySearchService.searchUsingRegex(this.get('savedReplies'), query.substr(1), this.savedReplySearchService.testName);
      let trieIds = results.mapBy('id');
      let uniqueRegexResults = regexResults.filter(regexResult => !trieIds.includes(regexResult.id));
      results = results.concat(uniqueRegexResults.slice(0, 5));
      if (results && results.length > 0) {
        results.forEach(result => {
          result.set('isHighlighted', false);
        });
        results[0].set('isHighlighted', true);
      }
    }
    this.set('matchingItems', results);
    this.showOrHide();
  }),
  init() {
    this._super(...arguments);
    this.set('sortKeys', [{
      key: 'sortInsertionsCount',
      reverse: true
    }, {
      key: 'name'
    }]);
  },
  insertItem() {
    this.clearTypedContent();
    let result = this.insertContentAndApplyEntity(' ', 'marker');
    return result.get('markerId');
  }
});